import config from '@/config';

export const generateInvitationLink = (token: string) => {
  return `${config.links.minasidor}/onboarding/membership?token=${token}`;
};
